import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  ValidatorFn,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentKnowledge2 } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentKnowledge2 & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<InvestmentKnowledge2 & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],

      riskProfil: this.formBuilder.group({
        stock1: [entity?.riskProfil?.stock1 || 'UNKNOWN'],
        stock2: [entity?.riskProfil?.stock2 || 'UNKNOWN'],
        privateEquity1: [entity?.riskProfil?.privateEquity1 || 'UNKNOWN'],
        privateEquity2: [entity?.riskProfil?.privateEquity2 || 'UNKNOWN'],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: InvestmentKnowledge2[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
  public oneValueRequired(): ValidatorFn {
    return (formGroup: UntypedFormGroup) => {
      // loop through all controls value if one of them is not UNKNOWN then return true else return false
      let isValid = false;
      for (const key in formGroup.controls) {
        if (formGroup.controls[key].value !== 'UNKNOWN') {
          isValid = true;
        }
      }
      if (isValid) {
        return null;
      }
      return { oneValueRequired: true };
    };
  }
}
// const avMonthlyPayment = formGroup.get("avMonthlyPayment").value;
//       const avInitialPayment = formGroup.get("avInitialPayment").value;

//       if (!avMonthlyPayment && !avInitialPayment) {
//         return { invalid: true };
//       }

//       return null;
//     };
